import { httpRequest } from "../../http";

/*
    Commenting on a GuidePost from the content page (MPN-1454).

    Its own command rather than a flag on cmdPostComment because it posts somewhere else:
    that one targets a todo, and the content page knows an ad. The server resolves which
    review the comment belongs to, which is also what stops a caller attaching one to a
    review it has nothing to do with.
*/
export class CommandPostAdComment {
    async run(
        organizationId: number,
        adId: number,
        comment: string,
        isClientVisible: boolean,
    ) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/ads/${adId}/comments/`;
        const formData = new FormData();
        formData.append(
            "data",
            JSON.stringify({
                organization: { id: organizationId },
                body: comment,
                is_client_visible: isClientVisible,
            }),
        );
        try {
            return await httpRequest<any>(url, {
                method: "POST",
                headers: { "Content-Type": "multipart/form-data" },
                body: formData,
            });
        } catch (error) {
            console.error("Error posting ad comment:", error);
            throw error;
        }
    }
}
